import { render, staticRenderFns } from "./youLove.vue?vue&type=template&id=46da793a&scoped=true"
import script from "./youLove.vue?vue&type=script&lang=js"
export * from "./youLove.vue?vue&type=script&lang=js"
import style0 from "./youLove.vue?vue&type=style&index=0&id=46da793a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46da793a",
  null
  
)

export default component.exports